import {AppLayout} from "../layout/AppLayout.tsx";
import {PublicHomePage} from "../features/home/pages/PublicHomePage.tsx";
import {PublicDetailPage} from "../features/domain-names/pages/PublicDetailPage.tsx";
import {AboutPage} from "../features/home/pages/AboutPage.tsx";
import {ProductsPage} from "../features/home/pages/ProductsPage.tsx";
import {SignOutPage} from "../features/home/pages/SignOutPage.tsx";
import {RequireAuth} from "../utils/RequireAuth.tsx";
import {IndexPage as DashboardPage} from "../features/dashboard/pages/IndexPage.tsx";
import {IndexPage as GettingStartedPage} from "../features/getting-started/pages/IndexPage.tsx";
import {DomainNamesLayout} from "../features/domain-names/layout.tsx";
import {DomainBulkImportLayout} from "../features/domain-bulk-import/layout.tsx";
import {RegistrarsLayout} from "../features/registrars/layout.tsx";
import {HostedZonesLayout} from "../features/hosted-zones/layout.tsx";
import {PlaceholderPage as ZonesPlaceholderPage} from "../features/zones/pages/PlaceholderPage.tsx";
import {DetailPlaceholderPage as ZoneDetailPlaceholderPage} from "../features/zones/pages/DetailPlaceholderPage.tsx";
import {PlaceholderPage as DnsRecordsPlaceholderPage} from "../features/dns-records/pages/PlaceholderPage.tsx";
import {PlaceholderPage as CertificatesPlaceholderPage} from "../features/certificates/pages/PlaceholderPage.tsx";
import {TopLevelDomainsLayout} from "../features/top-level-domains/layout.tsx";
import {SettingsLayout} from "../features/settings/layout.tsx";
import {ApplicationProductsLayout} from "../features/application-products/layout.tsx";
import {ApplicationErrorPage} from "@flexinet/ui-components";
import {PricingConfigProvider, PricingPage} from "@flexinet/pricing-components";
import {authenticatedPricingConfig, publicPricingConfig} from "./pricing.ts";


export const routesConfig = [{
    path: '/',
    element: <AppLayout/>,
    errorElement: <ApplicationErrorPage/>,
    children: [{
        index: true,
        element: <PublicHomePage/>
    }, {
        path: 'name/:name',
        element: <PublicDetailPage/>
    }, {
        path: 'about',
        element: <AboutPage/>
    }, {
        path: 'products',
        element: <ProductsPage/>
    }, {
        path: 'pricing',
        element: (
            <PricingConfigProvider config={publicPricingConfig}>
                <PricingPage/>
            </PricingConfigProvider>
        )
    }, {
        path: 'sign-out',
        element: <SignOutPage/>
    }, {
        path: 'dashboard',
        element: <RequireAuth><DashboardPage/></RequireAuth>
    }, {
        path: 'getting-started',
        element: <RequireAuth><GettingStartedPage/></RequireAuth>
    }, {
        path: 'domain-names/*',
        element: <DomainNamesLayout/>
    }, {
        path: 'domain-bulk-import/*',
        element: <RequireAuth><DomainBulkImportLayout/></RequireAuth>
    }, {
        path: 'registrars/*',
        element: <RequireAuth><RegistrarsLayout/></RequireAuth>
    }, {
        path: 'hosted-zones/*',
        element: <RequireAuth><HostedZonesLayout/></RequireAuth>
    }, {
        // FNP-1186 — placeholders registered ahead of FNP-1191 / FNP-1192 /
        // FNP-1193, so those tickets swap the element and never edit this file.
        path: 'zones',
        element: <RequireAuth><ZonesPlaceholderPage/></RequireAuth>
    }, {
        // FNP-1202: the detail route FNP-1186 omitted. Without it
        // /zones/<id> matched nothing and rendered the error boundary.
        path: 'zones/:zoneId',
        element: <RequireAuth><ZoneDetailPlaceholderPage/></RequireAuth>
    }, {
        // A record has no identity outside its zone, so the route nests.
        path: 'zones/:zoneId/records',
        element: <RequireAuth><DnsRecordsPlaceholderPage/></RequireAuth>
    }, {
        path: 'certificates',
        element: <RequireAuth><CertificatesPlaceholderPage/></RequireAuth>
    }, {
        path: 'top-level-domains/*',
        element: <RequireAuth><TopLevelDomainsLayout/></RequireAuth>
    }, {
        path: 'settings/*',
        element: <RequireAuth><SettingsLayout/></RequireAuth>
    }, {
        path: 'application-products/*',
        element: (
            <RequireAuth>
                <PricingConfigProvider config={authenticatedPricingConfig}>
                    <ApplicationProductsLayout/>
                </PricingConfigProvider>
            </RequireAuth>
        )
    }]
}]
